/*eslint-disable*/
import React from 'react'

// components
import { Typography, IconButton, Tooltip } from "@mui/material";
import InfoIcon from '../../assets/info-icon.svg'
import PropTypes from 'prop-types'

function InfoIconWithText({label, helpText, labelClassName=''}) {
  return (
    <div style={{ display: 'flex', alignItems: 'center', height: "24px" }}>
      {labelClassName && <div className={labelClassName}>{label}</div> }
      {!labelClassName && <Typography>{label}</Typography>}            
      <Tooltip sx ={{height: "30px"}} title={helpText} placement="top">
        <IconButton aria-label="info">
          <img
            src={InfoIcon}
            alt=""
            style={{ 
              height: '21px',
              pointerEvents: 'none',
              userSelect: 'none',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center'
            }}
          />
        </IconButton>
      </Tooltip>
    </div>
  )
}

InfoIconWithText.propTypes = {
    label: PropTypes.string,
    helpText: PropTypes.string,
}
  
InfoIconWithText.defaultProps = {
    label: '',
    helpText: '',
}

export default InfoIconWithText
